///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.event = abcsetup.event || {};
abcsetup.event.show = abcsetup.event.show || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.event.show = {
    init: function () {
        abcsetup.events.common.init();
    },
}